const API_URL = process.env.REACT_APP_API_URL || "https://maraton.klubmalydunaj.sk/api";

export const login = async (username, password) => {
    const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        credentials: "include", // Include cookies in the request
    });

    if (!response.ok) {
        throw new Error("Login failed");
    }

    return response.json();
};

export const register = async (username, password) => {
    const response = await fetch(`${API_URL}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        credentials: "include", // Include cookies in the request
    });

    if (!response.ok) {
        throw new Error("Registration failed");
    }

    return response.json();
};
